// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"0258e5be","453":"902fe954","578":"a6832de7","707":"04b89847","826":"1c3382a4","944":"c1396d4c"}[chunkId] + ".chunk.js";
};